import { LoginComponent } from '@app/login/login.component';
import { InputErrorMessage } from '@rxdi/forms';

import { AppErrors } from './errors';

export function EmailValidator(element: HTMLInputElement): InputErrorMessage<AppErrors> {
  if (!/^([a-zA-Z0-9_\.\-]+)@([a-zA-Z0-9_\.\-]+)\.([a-zA-Z]{2,5})$/.test(element.value)) {
    element.classList.add('is-invalid');
    return { key: 'email-validator', message: 'Email is not valid' };
  }
  element.classList.remove('is-invalid');
}

export function CreditCardValidator(element: HTMLInputElement) {
  const regex = /^[0-9s]{13,19}$/;
  if (!regex.test(element.value)) {
    element.classList.add('is-invalid');
    return {
      key: 'email-validator',
      message: 'Credit card number is invalid valid example xxxx-xxxx-xxxx-xxxx',
    };
  }
  element.classList.remove('is-invalid');
}

export function NetworkErrorValidator(this: LoginComponent): InputErrorMessage<AppErrors> {
  if (this.error && this.error.message === 'Network error: Failed to fetch') {
    return { key: 'network', message: 'network-comunication-error' };
  }
}

export function FirebaseAuthValidator(this: LoginComponent): InputErrorMessage<AppErrors> {
  if (this.error && this.error.code === 'auth/email-already-in-use') {
    return { key: this.error.code, message: this.error.message };
  }
  if (this.error && this.error.code === 'auth/user-not-found') {
    return { key: this.error.code, message: this.error.message };
  }
  if (this.error && this.error.code === 'auth/too-many-requests') {
    return { key: this.error.code, message: this.error.message };
  }
}
export function FirebasePasswordValidator(this: LoginComponent): InputErrorMessage<AppErrors> {
  if (this.error && this.error.code === 'auth/wrong-password') {
    return { key: this.error.code, message: this.error.message };
  }
}

export function PasswordValidator(element: HTMLInputElement) {
  if (!/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(element.value)) {
    element.classList.add('is-invalid');
    return {
      key: 'password-invalid',
      message: 'Minimum eight characters, at least one letter and one number',
    };
  }
  element.classList.remove('is-invalid');
}

export function NameValidator(element: HTMLInputElement) {
  if (!/^(?!.*\/)((?:.*\\.*)|$)/.test(element.value)) {
    return { key: 'name-invalid', message: 'Invalid project name' };
  }
}
